// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"842":"0be4b0e5","1054":"3475fb91","1584":"3475fb91","2313":"35e0ea1f","3072":"3475fb91","3294":"1f8192c5","3494":"3475fb91","5361":"c070aeed","6444":"3475fb91","6591":"3475fb91","8973":"59e6ef04"}[chunkId] + ".chunk.css";
};